import { useSubscriptionAccessConfigContext } from '@ltvco/refresh-lib/ctx';
import { SearchReportBanner } from '@ltvco/refresh-lib/fmt';
import {
  useReportRedirect,
  CollectionType,
  FeatureBlockedModal,
  useFeatureBlockedModal,
  type NullableAdvancedSearchURLParams,
} from '@ltvco/refresh-lib/v2';
import { useState } from 'react';

import imgPersonSearchBanner from 'images/imgPersonSearchBanner.svg';

interface SearchBannerProps {
  searchParams: NullableAdvancedSearchURLParams;
}

export function PersonSearchBanner({ searchParams }: SearchBannerProps) {
  const { redirectToSearchPersonUrlv2 } = useReportRedirect();
  const { isBlocked } = useSubscriptionAccessConfigContext();
  const {
    isFeatureBlockedModalOpen,
    openFeatureBlockedModal,
    closeFeatureBlockedModal,
  } = useFeatureBlockedModal();
  const [searchType, setSearchType] = useState<string>('');
  const [paymentShowModalNumber, setPaymentShowModalNumber] =
    useState<number>(0);

  const isDeceased: boolean | undefined =
    !!searchParams.deathYear ||
    (searchParams.birthYear && parseInt(searchParams.birthYear) < 1925)
      ? true
      : undefined;

  const personInfo: NullableAdvancedSearchURLParams = {
    ...searchParams,
    isDeceased,
    advancedSearch: true,
    source: [CollectionType.PUBLIC_RECORDS],
  };

  const displayName = searchParams.fName || searchParams.lName || 'this person';

  const handleClick = () => {
    if (isBlocked('person')) {
      setSearchType('Person');
      openFeatureBlockedModal();
      return;
    }

    redirectToSearchPersonUrlv2(personInfo);
  };

  return (
    <>
      <SearchReportBanner
        title={`Search for ${displayName}'s Person Report`}
        description="Look for more information in our public records data."
        buttonText="Go to Person Search"
        imageSrc={imgPersonSearchBanner}
        isDeceased={isDeceased}
        onButtonClick={handleClick}
      />

      <FeatureBlockedModal
        isOpen={isFeatureBlockedModalOpen}
        onClose={closeFeatureBlockedModal}
        searchType={searchType}
        paymentShowModalNumber={paymentShowModalNumber}
        setPaymentShowModalNumber={setPaymentShowModalNumber}
      />
    </>
  );
}
